import type { AuthorizationClaimsV2, TokenPayload } from './tokenTypes';

export const extractClaimsFromPayload = (payload: TokenPayload): string[] =>
    extractClaimsFromV2Payload(payload.claims)

function extractClaimsFromV2Payload(claims: AuthorizationClaimsV2 | undefined) {
    if (!claims || !Array.isArray(claims.ids_list) || !Array.isArray(claims.grants)) {
        return [];
    }

    const extractedClaims = new Set<string>();

    for (const grant of claims.grants) {
        if (
            !grant ||
            typeof grant.r !== 'string' ||
            !grant.r.trim() ||
            !Array.isArray(grant.a) ||
            !Array.isArray(grant.i)
        ) {
            continue;
        }

        for (const action of grant.a) {
            if (typeof action !== 'string' || !action.trim()) {
                continue;
            }

            for (const idIndex of grant.i) {
                if (!Number.isInteger(idIndex) || idIndex < 0 || idIndex >= claims.ids_list.length) {
                    continue;
                }

                const id = claims.ids_list[idIndex];
                if (typeof id === 'string' && id) {
                    extractedClaims.add(`${grant.r}:${action}:${id}`);
                }
            }
        }
    }
    return [...extractedClaims];
}
